import { render } from "./WhiteboardAiDrawer.vue?vue&type=template&id=2dbf53f3"
import script from "./WhiteboardAiDrawer.vue?vue&type=script&lang=js"
export * from "./WhiteboardAiDrawer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__